<div class="qa-codes">
	<app-rc-qa-codes [rules]="rules"></app-rc-qa-codes>
</div>
<div class="qa-content">
    <div class="align-wrap">
        <div class="left-content column-list">
            <div class="cell-item" *ngFor="let col of cols" appHtmlTooltip [tooltip]="col.htmlTooltip">{{col.label}}</div>
            <div class="cell-item">
                <!-- <app-button-except (click)="clickExcept()"></app-button-except> -->
            </div>
        </div>
        <div class="middle-content">
            <!-- <div class="address-points">
                <div *ngFor="let addr of addrList" class="cell-item">
                    <div class="address-draw"></div> 
                </div>
            </div> -->
            <div *ngFor="let col of cols" class="address-prop">
                <div *ngFor="let addr of addrList; let idx = index" class="cell-item" (click)="clickAddress(addr)">
                    <app-rc-cell [column]="col" [rcRecordItem]="addr" [domain]="addr.domainsByColumn[col.prop]" (edit)="onEdit(idx, $event)"></app-rc-cell>
                </div>
            </div>
            <div class="operation-buttons">
                <div *ngFor="let addr of addrList; let idx = index;" class="cell-item">
                    <app-button-switch [hidden]="idx === addrList.length - 1" (click)="switchLeftRight(idx)"></app-button-switch>
                </div>
            </div>
        </div>
    </div>
</div>